import React from 'react'

const textColorClasses = {
  'primary-1': 'primary-1',
  'primary-3': 'primary-3',
  'tertiary-3': 'tertiary-3',
  'tertiary-4': 'tertiary-4',
}

const fontFamilies = {
  serif: "'inferi-normal', serif",
  sans: "'basis-grotesque-regular', sans-serif",
}

export const PortableTextFontFamily = ({
  children,
  family,
}: {
  children: React.ReactNode
  family: keyof typeof fontFamilies
}) => (
  <span style={{ display: 'inline', fontFamily: fontFamilies[family] }}>
    {children}
  </span>
)

export const PortableTextColor = ({
  children,
  color,
}: {
  children: React.ReactNode
  color?: keyof typeof textColorClasses
}) => (
  <span
    className={color ? textColorClasses[color] : undefined}
    style={{ display: 'inline' }}
  >
    {children}
  </span>
)

export const PortableTextStrikethrough = ({
  children,
}: {
  children: React.ReactNode
}) => <s>{children}</s>
